module.exports = __webpack_public_path__ + "img/cisternerne.fe80ceeb.jpg";